<template>
  <div class="paper-warp" @scroll="onScroll($event)">
    <div v-if="data.is_dual_page === default_type" class="simple">
      <img
        v-if="data.is_dual_page === default_type"
        src="@/assets/picture/certificate_bg2_new.jpg"
        class="simple-bg"
      />
      <img v-if="data.seal_img" :src="data.seal_img" class="simple-seal" />
      <div class="simple-body">
        <div v-for="(item, index) in data.cert_data" :key="index" class="row">
          <div class="label">{{ item.label }}:</div>
          <div class="value">{{ item.value }}</div>
        </div>
        <img v-show="data.qr" class="qr" :src="data.qr" />
      </div>
    </div>
    <div v-else class="complex" :class="diretionFlag ? 'horizontal' : ''">
      <img src="@/assets/picture/certificate_bg_new.jpg" class="complex-bg" />
      <img v-if="data.seal_img" :src="data.seal_img" class="complex-seal" />
      <div class="left">
        <div class="head">
          <img v-if="data.head_img" :src="data.head_img" class="head-avator" />
          <!-- 没有照片就占个位子 -->
          <div v-else class="head-avator"></div>
          <div class="head-qr">
            <img v-show="data.qr" :src="data.qr" class="qr" />
          </div>
        </div>
        <div class="flex">
          <div class="complex-row flex flex-1" style="padding-right: 0;">
            <div class="row-left">
              <div class="label">{{ dataObj.name.label }}</div>
              <div class="subtitle">{{ dataObj.name.english_label }}</div>
            </div>
            <div class="row-right flex-1">{{ dataObj.name.value }}</div>
          </div>
          <div class="complex-row flex flex-1" style="padding-left: 10px;">
            <div class="row-left">
              <div class="label">{{ dataObj.sex.label }}</div>
              <div class="subtitle">{{ dataObj.sex.english_label }}</div>
            </div>
            <div class="row-right flex-1">{{ dataObj.sex.value }}</div>
          </div>
        </div>

        <div v-for="(item, index) in listLeft" :key="index" class="complex-row">
          <div v-if="item.label === '出生日期'" class="flex">
            <div class="col" style="padding: 0;">
              <div class="mainTitle">
                <span class="label">{{ item.label }}</span>
                <span class="value">
                  {{ dataObj.birthday.year }}
                  <span class="padding-lr">年</span>
                  {{ dataObj.birthday.month }}
                  <span class="padding-lr">月</span>
                  {{ dataObj.birthday.day }}
                  <span class="padding-lr">日</span>
                </span>
              </div>
              <div class="subtitle">
                <span>BirthDate</span>
                <span
                  class="subtitle-line"
                  style="flex: 2; margin: 0 4px 4px;"
                ></span>
                <span>Year</span>
                <span class="subtitle-line" style="margin: 0 4px 4px;"></span>
                <span>Month</span>
                <span class="subtitle-line" style="margin: 0 4px 4px;"></span>
                <span>Day</span>
              </div>
            </div>
          </div>
          <div v-else class="flex">
            <div class="row-left">
              <div class="label">{{ item.label }}</div>
              <div class="subtitle">{{ item.english_label }}</div>
            </div>
            <div class="row-right flex-1">{{ item.value }}</div>
          </div>
        </div>
      </div>
      <div class="right">
        <div>
          <div
            v-for="(item, index) in listRight"
            :key="index"
            class="complex-row flex"
          >
            <div class="row-left">
              <div class="label">{{ item.label }}</div>
              <div class="subtitle">{{ item.english_label }}</div>
            </div>
            <div class="row-right flex-1">{{ item.value }}</div>
          </div>
        </div>
        <div class="footer">
          <div class="complex-row">
            <div class="col">
              <div class="mainTitle">
                <span class="label">{{ dataObj.agency.label }}</span>
              </div>
              <div class="subtitle">
                {{ dataObj.agency.english_label }}
                <!-- <span class="subtitle-line"></span> -->
              </div>
            </div>
          </div>
          <div class="complex-row">
            <div class="col">
              <div class="mainTitle">
                <span class="label">{{ dataObj.date.label }}</span>
                <span class="value">{{ dataObj.date.value }}</span>
              </div>
              <div class="subtitle">
                {{ dataObj.date.english_label }}
                <!-- <span class="subtitle-line"></span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <mu-button
      v-if="data.is_dual_page !== default_type"
      fab
      small
      color="primary"
      class="move-button"
      @click="scroll"
    >
      <mu-icon :value="moveButton"></mu-icon>
    </mu-button>
    <mu-button
      v-if="data.is_dual_page !== default_type"
      fab
      small
      color="primary"
      class="window-change"
      @click="changeDirection"
    >
      <mu-icon value="crop_rotate"></mu-icon>
    </mu-button>
  </div>
</template>

<script>
import { CertDetail } from '@/api/index'
export default {
  name: 'Certificate',
  data() {
    return {
      default_type: 0,
      default_left_items: 4,
      diretionFlag: true,
      moveButton: 'arrow_forward',
      data: {},
      dataObj: {
        name: {},
        sex: {},
        date: {},
        agency: {},
        birthday: {
          year: null,
          month: null,
          day: null,
        },
      },
      user_avator: require('@/assets/default_avatar.jpg'),
      listLeft: [],
      listRight: [],
    }
  },
  computed: {},
  watch: {},
  created() {
    if (this.$route.query.id) {
      this.initPage(this.$route.query.id)
    } else {
      var obj = {}
      var query = window.location.href.split('?')[1]
      var vars = query.split('&')
      if (vars.length !== 0) {
        var pair = null
        for (var i = 0; i < vars.length; i++) {
          pair = vars[i].split('=')
          obj[pair[0]] = pair[1]
        }
        this.initPage(obj.id)
      }
    }
  },
  methods: {
    async initPage(id) {
      if (!id) return
      const res = await CertDetail({
        id: this.$route.query.id,
      })
      this.data = res
      console.log('this.data', this.data)
      this.setComplexData()
      // if (res.is_dual_page != this.default_type) {
      //   this.setComplexData()
      // }
    },
    setComplexData() {
      const certData = this.data.cert_data
      const data = []
      // const listLeft = []
      certData.map((item) => {
        switch (item.label) {
          case '性别':
            this.dataObj.sex = item
            break
          case '姓名':
            this.dataObj.name = item
            break
          case '发证日期':
            this.dataObj.date = item
            break
          case '发证机构名称及公章':
            this.dataObj.agency = item
            break
          case '出生日期':
            var birthday = {}
            var dayArr = item.value
              .replace('年', '-')
              .replace('月', '-')
              .replace('日', '-')
              .split('-')
            birthday.year = dayArr[0]
            birthday.month = dayArr[1]
            birthday.day = dayArr[2]
            this.dataObj.birthday = birthday
            data.push(item)
            break
          default:
            data.push(item)
        }
      })
      if (data.length >= this.default_left_items) {
        this.listLeft = data.splice(0, this.default_left_items)
        this.listRight = data
      } else {
        this.listLeft = data
        this.listRight = []
      }
    },
    changeDirection() {
      this.diretionFlag = !this.diretionFlag
    },
    scroll() {
      const paper = document.getElementsByClassName('paper-warp')[0]
      // paper.scrollLeft =
      //   this.moveButton === 'arrow_back' ? 0 : paper.scrollWidth
      this.scrollFunc(
        paper,
        this.moveButton === 'arrow_back' ? 'left' : 'right'
      )
    },
    onScroll(e) {
      const paper = document.getElementsByClassName('paper-warp')[0]
      let pWidth = paper ? paper.scrollWidth : 0
      const complex = document.getElementsByClassName('complex')[0]
      let eWidth = complex ? complex.offsetWidth / 4 : 0
      if (pWidth === 0 || eWidth === 0) return
      this.moveButton =
        e.target.scrollLeft >= eWidth ? 'arrow_back' : 'arrow_forward'
    },
    //匀速滚动
    scrollFunc(dom, direction) {
      const currentPosition = dom.scrollLeft //当前位置
      const scrollWidth = dom.scrollWidth //全长
      const moveLong =
        direction === 'left' ? currentPosition : scrollWidth - currentPosition //需要移动长度

      let sp = 10 //也可根据当前scrollTop动态改变sp的值，从而实现加速和减速滚动的效果
      let cont = Number.parseInt(moveLong / sp) //移动次数
      let oneLong = moveLong / cont //每次移动距离
      let step = 0
      let timer = setInterval(() => {
        if (step < cont) {
          dom.scrollLeft =
            direction === 'left'
              ? currentPosition - oneLong * step
              : currentPosition + oneLong * step
          step++
        } else {
          clearInterval(timer)
        }
      }, sp)
    },
    getMyData() {},
  },
}
</script>

<style lang="scss" scoped>
.paper-warp {
  width: 100vw;
  height: 100%;
  position: relative;
  overflow-y: auto;
}
.simple {
  font-size: 18px;
  // min-height: calc(100% - 16px);
  position: relative;
  .simple-bg {
    position: absolute;
    top: 0;
    z-index: 1;
    width: 100%;
  }
  .simple-seal {
    position: absolute;
    z-index: 2;
    width: 150px;
    height: 150px;
    bottom: 20px;
    right: 40px;
  }
  .simple-body {
    margin: 0 8px;
    padding: 16px 28px;
    position: relative;
    z-index: 3;
  }
  .row {
    padding: 4px 0;
    display: flex;
    align-items: center;
    .label {
      width: 120px;
      color: #777;
      font-size: 17px;
      letter-spacing: 0.1em;
      font-family: '宋体';
      font-weight: 600;
    }
    .value {
      flex: 1;
      padding-left: 10px;
      color: #000;
    }
  }
  .qr {
    width: 100px;
    height: 100px;
    margin-top: 8px;
    margin-bottom: 20px;
  }
}

.horizontal {
  transform: rotate(-90deg) translateY(-200vw);
  transform-origin: right top;
}

.complex-bg {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.complex-seal {
  position: absolute;
  z-index: 2;
  width: 150px;
  height: 150px;
  bottom: 40px;
  right: 40px;
}

.complex {
  width: 200vw;
  display: flex;
  overflow-x: scroll;
  overflow-y: scroll;
  transition-duration: 0.2s;
  position: relative;
  .left {
    flex: 1;
    position: relative;
    z-index: 2;
    padding: 40px 0;
    .head {
      width: 100vw;
      height: 240px;
      padding: 50px 40px 40px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      display: flex;
      align-items: center;
      // justify-content: center;
      .head-avator {
        width: 120px;
        // height: 100px;
      }
      .avator-empty {
        border: 2px solid #000;
        height: 140px;
      }
      .head-qr {
        // flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        .qr {
          width: 80px;
        }
        // height: 100px;
      }
    }
  }
  .complex-row {
    padding: 4px 32px;
    .row-left {
      font-family: '宋体';
      font-weight: 600;
      color: #666;
      .label {
        font-size: 18px;
      }
      .subtitle {
        margin-top: -6px;
        color: #666;
        font-family: 'Times New Roman';
        font-weight: 800;
      }
    }
    .row-right {
      flex: 1;
      margin-left: 8px;
      margin-bottom: 4px;
      border-bottom: 1px solid #333;
      font-size: 18px;
      text-align: center;
      color: #000;
      font-weight: 500;
    }
    .col {
      flex: 1;
      .mainTitle {
        display: flex;
        align-items: center;
        font-size: 18px;
        .padding-lr {
          padding: 0 12px;
        }
        .label {
          // letter-spacing: 0.1em;
          font-family: '宋体';
          font-weight: 600;
          color: #666;
          // width: 120px;
        }
        .label-short {
          width: 50px;
        }
        .value {
          flex: 1;
          text-align: center;
          color: #000;
          font-weight: 500;
        }
      }
      .subtitle {
        display: flex;
        align-items: flex-end;
        margin-top: -6px;
        color: #666;
        font-family: 'Times New Roman';
        font-weight: 800;
        .subtitle-line {
          flex: 1;
          margin-left: 8px;
          margin-bottom: 4px;
          border-bottom: 1px solid #333;
        }
      }
    }
  }
  .right {
    flex: 1;
    padding: 20px 0 0 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    z-index: 2;
  }
  .footer {
    padding-bottom: 20px;
  }
}
.window-change {
  position: fixed;
  right: 16px;
  bottom: 80px;
  z-index: 2;
}
.move-button {
  position: fixed;
  bottom: 130px;
  right: 16px;
  z-index: 2;
}
</style>
